const baseUrl = "yearOfStudy";
export const yearOfStudyUrl = ({ studentTypeId }) =>
	`${baseUrl}/${studentTypeId}`;
export const getLevelForBorrowCoursesUrl = (refCode) =>
	`${baseUrl}/levelForBorrowCourses${refCode ? `?refCode=${refCode}` : ""}`;
